export default __webpack_public_path__ + "static/media/aik.441e3f4e.jpeg";